export default "__VITE_ASSET__joCpJVjm__"